import { gql, useFragment } from "@apollo/client";

// Style
import style from "./ingredient-form.module.scss";

// Fragments
import { GET_FORM_FRAGMENT } from "utilities/gravity-forms";

// Components
import GravityForm from "@/components/gform/gravity-form";
import Container from "@/components-layout/container/container";

export default function IngredientForm({ data }) {
  // Use Fragment
  const formProps = useFragment({
    fragment: IngredientForm.fragments.gforms,
    fragmentName: "GFormFragment",
    from: {
      __typename: "RootQuery",
    },
  });
  const copyProps = useFragment({
    fragment: IngredientForm.fragments.copy,
    fragmentName: "IngredientFormFragment",
    from: data,
  });
  if (!formProps.complete || !copyProps.complete) {
    return;
  }

  // Variables
  const formCopy = copyProps.data;
  const gform = formProps.data?.gfForm;

  if (!formCopy.displayForm) {
    return;
  }

  return (
    <section id="ingrdForm" className={style.ingredientForm}>
      <Container className={style.formContainer}>
        <div className={style.formCopy}>
          <h2>{formCopy?.formTitle}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: formCopy?.formText,
            }}
          />
        </div>
        <GravityForm form={gform} />
      </Container>
    </section>
  );
}

IngredientForm.fragments = {
  gforms: gql`
    fragment GFormFragment on RootQuery {
      gfForm(id: "4") {
        ...getForm
      }
    }
    ${GET_FORM_FRAGMENT}
  `,

  copy: gql`
    fragment IngredientFormFragment on PageIngredientForm {
      __typename
      displayForm
      formTitle
      formText
    }
  `,
};
